import React from 'react';
import { Route } from 'react-router-dom';
import OAuth from './oauth';
import ShopifyAuth from './shopify';
import ChannelAdvisorAuth from './channeladvisor';
import LegacyOAuthDispatcher, { saveShopifyStoreName } from './legacy_dispatcher';

// An array, not a fragment: <Switch> treats a child without a `path` prop as an
// unconditional match and stops iterating, which would orphan every later route.
export const oauthRoutes = [
    <Route key="oauth-shopify" exact path="/oauth/shopify" render={() => (
        <LegacyOAuthDispatcher system="Shopify" legacy={ShopifyAuth} onInstall={saveShopifyStoreName} />
    )} />,
    <Route key="oauth-channeladvisor" exact path="/oauth/channeladvisor" render={() => (
        <LegacyOAuthDispatcher system="ChannelAdvisor" legacy={ChannelAdvisorAuth} />
    )} />,
    <Route key="oauth" path="/oauth" component={OAuth} />,
];
